import { EcardEmail } from './Ecard';
export default EcardEmail;
